import type { BridgeErrorCode } from '@oysterjs/smartfill-contracts';
import { SmartFillBridgeDisconnectedError, SmartFillBridgeRequestError } from './client';

export interface DisplayError {
  code: BridgeErrorCode | 'DISCONNECTED';
  message: string;
  retryable: boolean;
}

export function displayError(error: unknown, fallback: string): DisplayError {
  if (error instanceof SmartFillBridgeRequestError) {
    return {
      code: error.code,
      message: error.message,
      retryable: error.retryable
    };
  }
  if (error instanceof SmartFillBridgeDisconnectedError) {
    return {
      code: 'DISCONNECTED',
      message: error.message,
      retryable: true
    };
  }
  return {
    code: 'INTERNAL',
    message: error instanceof Error && error.message.trim() ? error.message : fallback,
    retryable: true
  };
}
